import React from 'react';
import Box, { BoxProps } from '@mui/material/Box';

type RootPageShape<D extends React.ElementType, P = {}> = {
  children: React.ReactNode;
} & BoxProps<D, P>;

function RootPage({ children, ...boxProps }: RootPageShape<React.ElementType>) {
  return (
    <Box
      display="flex"
      minHeight="100vh"
      maxWidth="lg"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      marginLeft="auto"
      marginRight="auto"
      gap={2}
      {...boxProps}
    >
      {children}
    </Box>
  );
}

export default RootPage;
